import { render, staticRenderFns } from "./CourseStatusList.vue?vue&type=template&id=9361c3ca&"
import script from "./CourseStatusList.vue?vue&type=script&lang=js&"
export * from "./CourseStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports